import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile,
} from 'firebase/auth';
import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { auth, db } from './config';

export const signUp = async (email, password, displayName) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  if (displayName) {
    await updateProfile(userCredential.user, { displayName });
  }
  await initUserProfile(userCredential.user.uid, displayName || email.split('@')[0]);
  return userCredential.user;
};

export const signIn = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return userCredential.user;
};

export const logout = () => signOut(auth);

export const subscribeToAuth = (callback) => onAuthStateChanged(auth, callback);

export const initUserProfile = async (uid, displayName) => {
  try {
    const userRef = doc(db, 'users', uid);
    const snapshot = await getDoc(userRef);
    if (!snapshot.exists()) {
      await setDoc(userRef, {
        displayName: displayName || 'Player',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),

        // Flutter parity fields (G-2)
        globalStreak: 0,
        lastPlayedGlobalDate: null,

        // Flutter parity stats fields (maps)
        wordMasterStats: {},
        crosswordStats: {},
        fullCrosswordStats: {},
        letterHiveStats: {},
        wordRungsStats: {},
      });
    }
  } catch (err) {
    if (err?.code === 'unavailable' || err?.message?.includes('offline')) {
      return;
    }
    throw err;
  }
};
